export class Post {
    _id = '';
    is_post_personal = false;
    max_group = 1;
    groups = Array();
    content = '';
    time_before_seeding_from = 2;
    time_before_seeding_to = 5;
    time_after_content_from = 2;
    time_after_content_to = 4;
    time_after_seeding_from = 2;
    time_after_seeding_to = 4;
}


// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_models/auto_seeding/post.ts